export default "__VITE_ASSET__1bf935aa__"